import { render, staticRenderFns } from "./IncludedExpenseRoyalty.vue?vue&type=template&id=1f719867&scoped=true"
import script from "./IncludedExpenseRoyalty.vue?vue&type=script&lang=js"
export * from "./IncludedExpenseRoyalty.vue?vue&type=script&lang=js"
import style0 from "./IncludedExpenseRoyalty.vue?vue&type=style&index=0&id=1f719867&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f719867",
  null
  
)

export default component.exports